import { createSlice } from "@reduxjs/toolkit";

interface ThemeState {
  theme: string;
}

const initialState: ThemeState = {
  theme: "PARENT",
};

const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    activateParentTheme: (state) => {
      state.theme = "PARENT";
    },
  },
});
export const { activateParentTheme } = themeSlice.actions;
export default themeSlice;
